<template>
<div class="uploadPopper">
    <moo-popover popper-class="common-popper upload-popper" placement="bottom-end" width="160" trigger="hover" :close-delay="0" v-model="addVisible">
        <moo-tooltip effect="light" :content="uploadTip" placement="right-start" popper-class="home-upload-tooltip-class" :visible-arrow="false">
            <div class="upload-file-popper">
                <span @click="(event) => handleUpload(data.type)" :key="data?.icon" v-for="data in headerUpload">
                    <div class="upload-tip">
                    <svg-icon class-name="file-icon" :icon-class="data.icon"></svg-icon>
                    {{ data?.resourceName }}
                </div>
                </span>
            </div>
      </moo-tooltip>
      <div class="upload" slot="reference">
        <uploadIcon class="upload-icon"></uploadIcon>
        <div class="content">
          <div class="title">{{$t("上传#!!!#src/pages/CloudHome/components/UploadEntrance.vue_1")}}</div>
          <div class="tip">{{$t("上传本地文件#!!!#src/pages/CloudHome/components/UploadEntrance.vue_1")}}</div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.21428571 4.64285714" class="download-btn-icon design-iconfont">
          <path id="file-unselected-svg" d="M2.65690708,8.3711928 C2.44769764,8.58040224 2.44769764,8.91959776 2.65690708,9.1288072 C2.86611652,9.33801665 3.20531205,9.33801665 3.41452149,9.1288072 L6.98595006,5.55737863 C7.1951595,5.34816919 7.1951595,5.00897367 6.98595006,4.79976422 L3.41452149,1.22833565 C3.20531205,1.01912621 2.86611652,1.01912621 2.65690708,1.22833565 C2.44769764,1.43754509 2.44769764,1.77674062 2.65690708,1.98595006 L5.84952845,5.17857143 L2.65690708,8.3711928 Z" fill="#646A73" fill-rule="nonzero" transform="rotate(90 5.892857 3.392856)"></path>
        </svg>
      </div>
    </moo-popover>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import uploadIcon from '../assets/uploadIcon.vue';

export default {
  props: {},
  name: "uploadPopper",
  components: { uploadIcon },
  data() {
    return {
      addVisible: false,
      uploadTip: intl.$t("支持以下文件格式：#!!!#src/pages/CloudHome/components/UploadEntrance.vue_1") + "\n.doc、.docx、.xls、.xlsx、.ppt、.pptx、.pdf"
    };
  },
  methods: {
    refresh() {
      // 新建刷新列表
      this.$emit("refresh");
    },
    handleUpload(value) {
      this.$emit("handleUpload", value);
      this.addVisible = false;
      return;
    }
  },
  computed: {
    headerUpload() {
      return [
      {
        resourceName: intl.$t("上传文件#!!!#src/pages/CloudHome/components/UploadEntrance.vue_1"),
        icon: "file-upload",
        type: "UPLOADFILE",
        tip: this.uploadTip
      },
      {
        resourceName: intl.$t("上传文件夹#!!!#src/pages/CloudHome/components/UploadEntrance.vue_1"),
        icon: "folder-upload",
        type: "UPLOADFOLDER",
        tip: this.uploadTip
      }];

    }
  },
  watch: {},
  mounted() {},
  destroyed() {}
};
</script>

<style lang="scss">
.uploadPopper {
  width: 220px;
  height: 58px;
}
.common-popper {
  width: 146px !important;
  background: transparent !important;
  height: 112px;
  background: #ffffff;
  border: none !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  box-sizing: border-box;
  height: auto !important;
  width: 146px !important;
  margin-top: 8px !important;
  padding: 8px 0 0 0 !important;

  .popper__arrow {
    display: none !important;
  }
}

.common-popper.upload-popper {
  top: 112px !important;
  width: 220px !important;
  margin-top: 8px !important;
}

.header-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 16px !important;
  height: 16px !important;
}

.header-icon:hover {
  background: #f4f6f9;
  border-radius: 4px;
}

.upload {
  width: 220px;
  height: 58px;
  background: #ffffff;
  border: 1px solid #efeff0;
  border-radius: 6px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  box-sizing: border-box;

  .upload-icon {
    width: 26px;
    height: 26px;
  }

  .content {
    flex: 1;
    padding: 0 16px;
    box-sizing: border-box;
    .title {
      line-height: 20px;
      margin-bottom: 1px;
      font-weight: 500;
      font-size: 14px;
    }

    .tip {
      line-height: 17px;
      font-weight: 400;
      font-size: 12px;
      color: #646573;
    }
  }

  .download-btn-icon {
    width: 10px;
    height: 10px;
    margin-left: 4px;
  }
}

.upload:hover {
  border: 1px solid #5c70ff;
}

.upload:hover {
  .download-btn-icon {
    #file-unselected-svg {
      fill: #5c70ff !important;
    }
    transform: rotate(180deg);
  }
}

.upload-file-popper {
  display: flex;
  flex-direction: column !important;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;
  padding: 4px 4px !important;
  border-radius: 8px !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  background-color: #ffffff !important;

  span {
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    letter-spacing: 0;
    width: 100%;
    height: 44px;
    padding-bottom: 4px;
    border-radius: 8px;
    line-height: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    position: relative;

    .upload-tip {
      width: 212px;
      height: 100%;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 8px;

      &:hover {
        background: #f4f6f9;
      }
    }

    .file-icon {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin: 0 8px;
    }

    .upload-file {
      width: 16px;
      height: 16px;
      margin: 0 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      margin: auto 0;
    }
  }
}
</style>

<style lang="scss">
.home-upload-tooltip-class {
    margin-left: 8px !important;
    width: 171px !important;
    padding: 12px 8px !important;
    border-radius: 8px !important;
    background: #FFFFFF !important;
    border: 1px solid #E6E8EC !important;
    box-shadow: 0 8px 12px 0 #1213171a !important;
    color: #8d8f99 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
}
</style>
